<script>
    import { onMount } from 'svelte';
    import AddToCartButton from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/AddToCartButton.svelte?1733898724885';
    import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898724885';
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724885';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724885';
    import StockNotificationButton from '/srv/web/wyvr/html/releases/58819/gen/client/stock_notification/Button.svelte?1733898724885';
    import PriceRequestButton from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/Button.svelte?1733898724885';
    import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898724885';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let product = undefined;
    export let sku = undefined;
    export let disabled = false;
    export let add_text = undefined;
    export let remove_text = undefined;
    let in_cart = false;
    let cart_skus = [];

    // when the products changes the sku also have to change
    $: update_sku(product);
    $: stock = get_stock(product);
    $: in_stock = stock?.is_in_stock || false;
    $: disabled = !in_stock;
    $: price_request = get_price_request(product);

    onMount(() => {
        if (!sku && product) {
            sku = get_attribute_value(product, 'sku');
        }
        disabled = !in_stock;
        // when the product is already in the cart use the given qty
        cart.subscribe((cart) => {
            const skus_in_cart = cart?.items?.map((item) => item?.sku).filter(Boolean);
            if(Array.isArray(skus_in_cart)) {
                cart_skus = skus_in_cart;
            }
            update_disabled();
        });
    });

    function update_sku(product) {
        if (product) {
            sku = get_attribute_value(product, 'sku');
        }
        update_disabled();
    }
    function update_disabled() {
        in_cart = cart_skus?.indexOf(sku) > -1;
        disabled = !in_stock || in_cart;
    }
</script>

<div class="add-to-cart-btn-wrapper">
    {#if in_stock}
        {#if price_request}
            <PriceRequestButton {product} />
        {:else}
            <AddToCartButton {sku} {disabled} qty={1} {add_text} {remove_text} on:click />
        {/if}
    {:else}
        <StockNotificationButton {product} />
    {/if}
</div>



<style>
</style>